<template>
    <div class="vDialog" v-show="display" @click="hide">
        <div class="inner">
            <img src="../assets/popbg.png" alt="">
            <span class="msg">{{msg}}</span>
        </div>
    </div>
</template>

<script>
    module.exports = {
        data: function () {
            return {
                type: true
            }
        },
        props: ["display","msg"],
        components: {
        },
        methods: {
            hide: function () {
                this.display = false
            }
        }
    }
</script>

<style scoped>
    .vDialog {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
    }
    .inner{
        position: absolute;
        width: 80%;
        top: 25%;
        left: 10%;
    }
    .msg {
        position: absolute;
        top: 52%;
        left: 33%;
        width: 40%;
        line-height: 1.6;
        color: #6d7474;
        font-size: 14px;
    }
    .vDialog img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// Dialog.vue?287380ba